import { Component, input, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputFieldComponent, SelectOptions } from '@app/components/input-field/input-field.component';
import { AutoForm } from '@app/interfaces/auto-form.interface';
import { FirmwareCreate } from '@app/models/firmware.interface';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-firmware-form',
    imports: [
        ReactiveFormsModule,
        InputFieldComponent,
    ],
    templateUrl: './form.component.html',
    styleUrl: './form.component.scss'
})
export class FirmwareFormComponent {
  initialValue = input<FirmwareCreate>();
  formChange = output<FirmwareCreate>();
  formValid = output<boolean>();

  firmwareForm = new FormGroup<AutoForm<FirmwareCreate>>({
    name: new FormControl<string>('', { validators: [Validators.required], nonNullable: true}),
    firmware_version: new FormControl<string>('', { validators: [Validators.required], nonNullable: true}),
  });

  constructor() {
    toObservable(this.initialValue).subscribe((initial) => {
      if(initial) {
        Object.keys(initial).forEach(key => {
          // https://stackoverflow.com/a/62438434/3341745
          let prop = key as keyof typeof initial;
          if(initial[prop] != null) {
            this.firmwareForm.get(key)?.setValue(initial[prop]);
          }
        });
      }
      this.onChange();
    });
  }

  onChange() {
    this.formValid.emit(this.firmwareForm.valid);
    this.formChange.emit(<FirmwareCreate>this.firmwareForm.value);
  }
}